
  <div class="spinner-border" [ngClass]="class" role="status" [ngStyle]="{'width': size, 'height':size } " *ngIf="enabled">
    <span class="sr-only">Loading...</span>
  </div>